import { __ } from '@wordpress/i18n';

// companies api
export const ROOT_REDUCER_PATH = "apiReducer";

// base api url
export const BASE_API_URL = jobboardApp.baseApiURL;

// base name for companies rest api
export const COMPANIES_API = "companies/";

// base name for filters rest api
export const FILTERS_API = "/company-filters/";

// sorting rules object
export const SORTING_RULES = {
	RECOMMENDED: "recommended",
	ASC_ALPHA: "a-z",
	DESC_ALPHA: "z-a",
	NEWEST: "newest",
};

// slice name for forms input data
export const FORM_INPUT_SLICE_NAME = "formInput";

export const sortingOptions = [
	{ value: "recommended", label: __("Recommended", "job") },
	{ value: "a-z", label: __("A - Z", "job") },
	{ value: "z-a", label: __("Z - A", "job") },
	{ value: "newest", label: __("Newest", "job") },
];

export const SORTING_VALUES_ARR = ["recommended", "a-z", "z-a", "newest"];

/**
 * Styling for dropdown sorting filter
 */

export const dropdDownStyles = {
	control: (base) => ({
		...base,
		// height: 40,
		// minHeight: 40,
		// borderRadius: 12,
		// border: "1px solid #D9DFE8",
		boxShadow: "none",
	}),
	dropdownIndicator: (base) => ({
		...base,
		color: "#3B556B",
	}),
	menu: (base) => ({
		...base,
		borderRadius: 12,
		padding: 8,
	}),
	option: (base, state) => {
		let backgroundColor = "white";
		let cursor = "default";
		let border = "none";
		let marginTop = "initial";
		let marginBottom = "initial";

		if (state.isSelected) {
			backgroundColor = "#E8F2FA";
			marginTop = "4px";
			marginBottom = "4px";
		}

		if (state.isFocused) {
			cursor = "pointer";
			border = "1px solid #1478c8";
		}

		return {
			...base,
			borderRadius: 12,
			backgroundColor,
			color: "#10324C",
			cursor,
			border,
			marginTop,
			marginBottom
		};
	},
};

// constants for amplitude values
export const RESET_INPUT_APPLIED = "filter_reset";

export const SORT_DROPDOWN_CHANGED = "sorting_apply";

export const COMPANY_CARD_CLICKED = "company_card_clicked";

export const TEXT_SEARCH_APPLIED = "search_keyword_submit";

export const TEXT_SEARCH_ENTER_PRESSED = "keyboard_button_press";

export const TEXT_SEARCH_BLURRED = "form_focus_company";
